import { createFileRoute } from "@tanstack/react-router";
import { JoinPage } from "../features/auth/JoinPage";

export const Route = createFileRoute("/join")({
  validateSearch: (s: Record<string, unknown>): { token: string } => ({
    token: typeof s.token === "string" ? s.token : "",
  }),
  component: () => <JoinPage token={Route.useSearch().token} />,
});
